/**
 * @desc 导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.certificationDocument.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/certificationDocument/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
